// eslint-disable-next-line import/no-anonymous-default-export
export default {
  translation: {

    // General
    yes: "Sí",
    no: "No",
    cancel: "Cancelar",
    showingRows: "Mostrando {{shown}} / {{total}}",
    close: "Cerrar",
    caution: "Caution",
    actionsForSelection: "Acciones para la selección",

    processStatus:
    {
      INITIALIZED: 'Inicializado',
      UPLOADED: "Archivos Cargado",
      STARTED: "Se está procesando",
      PROCESSED: "Se ha procesado",
      FAILED: "Fallido",
      DISABLED: "Deshabilitado",
      FINISHED: "Finalizado",
      PAUSED: "Pausado",
      TRIGGERED: "Iniciado",
      DELETED: "Eliminado",
      DELETING: "Siendo eliminado",
      PROBLEM: "En reparación",
      statusMapping: "La información sobre el estado del proceso se puede encontrar en la documentación.",
      description: {
        INITIALIZED: "Los datos se están preparando para el procesamiento",
        UPLOADED: "Los datos se han cargado y el procesamiento comenzará pronto",
        STARTED: "El procesamiento de los datos ha comenzado. Puede tardar horas o incluso días dependiendo de la cantidad de datos y la carga del sistema. Si la carga es baja y tarda más de lo esperado, por favor contacte con el soporte.",
        PROCESSED: "Los datos han sido procesados y los metadatos se están preparando.",
        FAILED: "El procesamiento no se puede completar, ocurrió un error que no podemos resolver. Esto puede deberse a los datos cargados.",
        DISABLED: "El procesamiento fue deshabilitado por un administrador. Los datos del proceso no están disponibles para ser visualizados.",
        FINISHED: "El procesamiento se ha completado con éxito. Los datos son visibles en los visores. Bajo Acceso de Usuario a Procesos se puede habilitar la visualización de datos para usuarios estándar.",
        PAUSED: "/Tipo: Video V2B únicamente/ El procesamiento está pausado. Se reanudará manualmente.",
        TRIGGERED: "El proceso de procesamiento ha sido iniciado.",
        DELETED: "El proceso y los datos asociados han sido eliminados.",
        DELETING: "El proceso y los datos asociados están siendo eliminados",
        PROBLEM: "Durante el procesamiento de los datos, ocurrió un problema y estamos intentando resolverlo. Puede tomar algún tiempo, dependiendo de la gravedad del problema. Si se resuelve, el estado se actualizará a `Procesando` y si no, a `Fallido`.",
      }
      //   INITIALIZED: "Data is being prepared for processing", // translate in spanish
      //   UPLOADED: "Data is uploaded and processing will start", // shall we show the same status as for STARTED?
      //   STARTED: "Data processing has started. It can take hours or even days depending on the data quantity and system load. If load is little and it takes longer than expected, please contact the support.", // longer than expected?
      //   PROCESSED: "The data was processed and metadata is being prepared.",
      //   FAILED: "The processing cannot be completed, an error occurred that we cannot resolve. This may be due to the uploaded data.",
      //   DISABLED: "The processing was disabled by an administrator. Process data is not available to be viewed.", // What user can do?
      //   FINISHED: "The processing has successfully finished. The data is visible in the viewers. Under Processes User Access the data viewing can be enabled for standard users.", // would be good to say user type, or guide where to check if he has viewing permissions
      //   PAUSED: "/Type: Video V2B only/ The processing is paused. It will be manually resumed.", // no user input, right?
      //   TRIGGERED: "The processing process has been triggered.", // shall we show the same status as for STARTED?
      //   DELETED: "The process and the associated data have been deleted.",
      //   DELETING: "The process and the associated data are being deleted",
      //   PROBLEM: "While processing the data, a problem has occurred and we are trying to resolve it. It might take some time, depending on the severity of issued. If resolved, the status will update to `Processing` and if not, to `Failed`.",
      // },
    },

    systemHealth: {
      title: "Estado del sistema uploader",
      summaryTitle: "Carga del sistema",
      LOW: "Carga baja",
      MEDIUM: "Carga media",
      HIGH: "Carga alta",
      VERY_HIGH: "Carga muy alta",
      description: {
        LOW: "Actualmente se están procesando muy pocos procesos y no debería tardar mucho en procesarse sus datos.",
        MEDIUM: "Actualmente se están procesando muchos procesos y podría tardar un tiempo en procesarse sus datos.",
        HIGH: "Actualmente se están procesando muchos procesos y podría tardar un tiempo en procesarse sus datos.",
        VERY_HIGH: "Actualmente se están procesando muchos procesos y podría tardar mucho en procesarse sus datos.",
      },
      loading: "Cargando estado del uploader...",
      error: "No se pudo cargar el estado del uploader",
      lastUpdated: "Última actualización",
    },
    // User Access
    ua: {
      loading: "Cargando...",
      project_not_loaded: "No se pudo cargar el proyecto",
      access_denied: "Acceso denegado",
      user_access: "Acceso a usuarios",
      user_name: "Nombre de usuario",
      email: "Correo electrónico",
      roles: "Roles", //TODO
      email_address: "Dirección de correo electrónico",
      add_user: "Agregar usuario",
      import_user: "Importar usuarios desde archivo",
      select_none: "No seleccionar\nninguno",
      select_all: "Seleccionar\ntodos",
      remove_all: "Remover\ntodos",
      remove_selected: "Remover\nseleccionados",
      export_all: "Exportar\ntodos",
      export_selected: "Exportar\nseleccionados",
      copy_user_id: "Copiar ID de usuario",
      remove_user: "Remover usuario",
      copy_id: "Copiar ID de usuario",
      id_copied: "ID de usuario copiado",
      process_access: "Acceso por proceso",
      process_filter: "Filtrar procesos",
      remove_process_filter: "Remover filtro de procesos",
      sections_and_processes: "Secciones y procesos finalizados",
      external: "Externos",
      internal: "Internos",
      collapse_expand_processes: "{{collapse}} esta sección",
      collapse: "Contraer",
      expand: "Expandir",
      alerts: {
        wrong_filetype: "No se puede procesar el archivo '{{file}}' porque no es un archivo de texto.",
        user_not_added: "Los siguientes usuarios no pudieron ser agregados al proyecto",
        user_in_project: "El usuario ya tenía acceso al proyecto",
        user_added: "El usuario fue agregado al proyecto exitosamente",
        user_not_removed: "Los siguientes usuarios no pudieron ser removidos del proyecto",
        remove_all_users: "¿Realmente desea eliminar todos los usuarios del proyecto?",
        remove_selected_users: "¿Realmente desea eliminar todos los usuarios seleccionados?",
        external_not_switched: "El acceso a trabajores externos no pudo ser modificado",
        internal_not_switched: "El acceso a trabajores internos no pudo ser modificado",
        process_not_switched: "El acceso al proceso no pudo ser modificado",
      },
    },

    // Viewer
    v: {
      loading: "Cargando...",
      too_many_containers: "El número máximo de espectadores es 3. " +
        "Por favor, cierre uno antes de continuar.",
      multiple_3d: "Múltiples contenedores 3D",
      multiple_3d_text: "Está a punto de abrir más de un contenedor 3D. " +
        "Esto puede provocar que las nubes de puntos se carguen más despacio de lo normal. " +
        "Por eso se recomienda limitar el tamaño máximo de la nube de puntos. " +
        "¿Quieres limitar las nubes de puntos a un tamaño máximo de 250.000 puntos?" +
        "También puedes cambiar el tamaño máximo de las nubes de puntos en cualquier momento en la configuración del menú 'PUNTOS'.",
      add_panorama: "Has abierto varios contenedores 3D. " +
        "¿En qué contenedor debe mostrarse la imagen panorámica?",
      multiple_panoramas: "Varias imágenes panorámicas encontradas",
      multiple_panoramas_text: "Aquí encontrará imágenes panorámicas de varios procesos. " +
        "¿Qué imagen panorámica de qué proceso le gustaría mostrar?",
      other_process: "Imagen panorámica de otro proceso",
      other_process_text: "La imagen panorámica seleccionada pertenece a un proceso diferente al de la imagen mostrada actualmente. " +
        "¿Desea continuar?",
      none: "Ninguno / Cancelar",
      close: "Cerrar",
      process_overlay_next_page: "{{count}} más antiguos...",
      process_overlay_prev_page: "{{count}} más nuevos...",
      projectWithoutProcess: "Este proyecto no contiene procesos o no está disponible.",
      noImages: "Aquí no hay imágenes o se procesaron antes de 2023",
      displayProfile: "Ver perfil",
      errorProfileAdding: "El perfil no se ha podido añadir a ninguno de los visores 3D actuales porque al menos un punto no está en una nube de puntos activa",
      errorProfileAddingNew: "El perfil no se ha podido añadir al un nuevo visor 3D porque al menos un punto no está en una nube de puntos activa",
      noActiveThreeDViewer: "Para que se muestre un perfil, debe estar activo en un visor 3D. Actualmente hay demasiados visores abiertos para añadir un nuevo visor 3D",
      invalidContainer: "Contenedor inválido para eliminar",
      automaticLoadingProcesses: "La carga automática de procesos se basa en el mapa de la izquierda",
      automaticLoading: "Se requiere una mapa para la carga automática.",
      measurementAlreadyActiveHeader: "Medición activa",
      measurementAlreadyActive: "Ya hay una medida activa. Debe finalizarse e iniciarse una nueva?",
      editingAlreadyActiveHeader: "Edición activa",
      editingAlreadyActive: "Ya se está editando una medición. Desea salir del modo de edición e iniciar una nueva medición?",
      addProfileToCurrent: "Para que un perfil se muestre, debe estar activo en un visor 3D. ¿Debe añadirse este perfil a uno de los visores 3D actuales?",
      addProfileToNew: "Para que un perfil se muestre, debe estar activo en un visor 3D. ¿Desea añadir un nuevo visor 3D? Nota: esto puede tardar unos segundos",
      alert: "Eso no debería pasar",
      max_active_geo_layers: "Se pueden activar como máximo {{count}} capas GEO/Objetos al mismo tiempo.",
      gnd_profile_requires_layer: "Un perfil requiere una capa GND visible en el visor 3D.",
      gnd_profile_no_visible_line: "No hay ninguna línea GND seleccionable visible en la vista 3D actual.",
      gnd_profile_failed: "No se pudo crear el perfil.",
      axis_measurement_requires_km_layer: "Esta medición requiere una capa de kilometraje (GND) visible en el visor 3D.",
      axis_measurement_requires_track_layer: "Esta medición requiere una capa de ejes de vía (GND) visible en el visor 3D.",
      axis_measurement_no_visible_axis: "No hay ningún eje seleccionable visible en la vista 3D actual.",
      axis_measurement_no_km_data: "El eje seleccionado no contiene datos de kilometraje.",
      axis_measurement_km_data_problem: "Problema con los datos de la red ferroviaria.",
      axis_measurement_failed: "No se pudo completar la medición del eje.",
      windows: {
        catalog: "Catálogo",
        measurements: "Mediciones",
        layer_menu: "Menú de capas",
        gis_object: "Objeto SIG",
      },
      axis_measurement_names: {
        KILOMETRIERUNG: "Kilometraje",
        KILOMETRIERUNG_DISTANCE: "Eje kilométrico",
        GLEISACHSE_DISTANCE: "Eje de vía",
        GLEISACHSE_GAP: "Distancia al eje",
      },
      measurement_details: {
        results: "Resultados",
        resample_elevation: "Tomar las elevaciones de la nube de puntos",
        total_length: "Longitud total",
        projected_length: "Longitud proyectada",
        vertical_extent: "Extensión vertical",
        line_details: "Detalles ({{segments}} segmentos, {{vertices}} vértices)",
        segments: "Segmentos ({{count}})",
        segment: "Seg. {{n}}",
        slope: "Pendiente",
        vertices: "Vértices ({{count}})",
        add_point: "Añadir punto",
        area_2d: "Área (2D)",
        perimeter: "Perímetro",
        polygon_details: "Detalles ({{edges}} aristas)",
        edges: "Aristas ({{count}})",
        edge: "Arista {{n}}",
        fill: "Relleno",
        cut: "Desmonte",
        total_volume: "Volumen total",
        height_difference: "Diferencia de altura (ΔZ)",
        horizontal_distance: "Distancia horizontal",
        distance_3d: "Distancia 3D",
        base_point: "P1 (base)",
        compare_point: "P2 (comparación)",
        volume_options: "Opciones de cálculo (volumen)",
        flatten: "Aplanar a un plano",
        plane_height: "Altura del plano",
        undo_flatten: "Deshacer (restaurar las alturas originales)",
        max_height: "diferencia de altura máxima",
        max_height_hint: "Distancia máxima de un punto al plano de referencia para que se cuente",
        name: "Nombre",
        description: "Descripción",
        type_point: "Punto",
        type_line: "Línea",
        type_polygon: "Polígono",
        type_volume: "Volumen",
        type_height_difference: "Diferencia de altura",
        labels: "Etiquetas",
        mirror: "Reflejar en la otra vista",
        finish_edit: "Terminar la edición",
        edit: "Editar",
        recalc_volume: "Recalcular el volumen",
        open_profile: "Abrir perfil",
        zoom_to: "Acercar",
      },
      axis_details: {
        km: "Kilometraje",
        km_data: "Datos de la red ferroviaria",
        side: "Lado",
        distance_to_axis: "Distancia al eje",
        series: "Serie",
        role: "Tipo",
        calibration: "Calibración",
        calibration_offset: "Desplazamiento calibrado",
        distance_along_axis: "Distancia a lo largo del eje",
        distance_to_track_centre: "Distancia al centro de la vía",
        distance_to_gnd_axis: "Distancia al eje GND",
      },
      clip_reference_requires_axis_layer: "Para cortar a lo largo de un eje debe haber una capa de ejes SIG (GND) visible en el visor 3D.",
      clip_reference_no_visible_axis: "No hay ningún eje seleccionable visible en la vista 3D actual.",
      max_active_geo_layers_short: "Max. {{count}}",
      too_many_panoramas: "X2BIM no admite actualmente la visualización simultánea de imágenes panorámicas en distintos contenedores.",
      panorama_currently_active: "Una imagen panorámica asociada a este proceso se muestra actualmente en el contenedor 3D. " +
        "Salga del modo panorámico antes de eliminar este proceso del contenedor.",

      // Menubar
      mb: {
        ortho: "Ortográficas",
        plan: "Planos",
        dgm: "Terreno",
        pointcloud: "Puntos",
        panorama: "360°",
        uav_lite: "Fotos",
        glb: "IFC",
        video: "Vídeo",
        ki: "Geo/Objetos",
        annotation: "Anotaciones",
        ortho_long: "Imágenes ortográficas",
        plan_long: "Planos",
        dgm_long: "Modelo de elevación de terreno",
        pointcloud_long: "Nube de puntos",
        panorama_long: "Imágenes panorámicas",
        glb_long: "modelos IFC",
        video_long: "Vídeo de ruta",
        ki_long: "Objectos-IA",
        annotation_long: "Anotaciones",
        ortho_help: "La última imagen ortográfica agregada es la que se muestra en la parte superior del mapa. " +
          'Al seleccionar "Recargar recursos automáticamente", los datos se añaden cronológicamente, con el proceso más reciente en la parte superior.',
        plan_help: "Los planos se dividen en teselas y se muestran en el mapa de la misma forma que las imágenes ortográficas. " +
          'Al seleccionar "Recargar recursos automáticamente", los datos se añaden cronológicamente, con el proceso más reciente en la parte superior. ' +
          "Los planos siempre se superponen sobre las imágenes ortográficas y los modelos de elevación de terreno.",
        dgm_help: "Los modelos de elevación de terreno se dividen en teselas y se muestra en el mapa con una resolución inferior a la de las imágenes ortográficas. " +
          'Al seleccionar "Recargar recursos automáticamente", los datos se añaden cronológicamente, con el proceso más reciente en la parte superior. ' +
          "Los modelos de elevación de terreno siempre se superponen sobre las imágenes ortográficas.",
        pointcloud_help: "Para una mejor orientación en el visor de nubes de puntos 3D, siempre debe mostrarse al menos una nube de puntos. " +
          'La configuración de cámara "Modo Earth" sólo funciona a partir de una nube de puntos superpuesta',
        panorama_help: "Actualmente es posible subir imágenes panorámicas para los proyectos del tipo Video2BIM y Multisensorplattform. " +
          "Después de seleccionar una imágen panorámica en el visor 2D o 3D, se muestra en el visor 3D. Para salir de la vista utilice el botón en la parte inferior del visor. " +
          "Hacer mediciones en la imagen panorámica solo es posible cuando una nube de puntos que se muestra simultáneamente.",
        glb_help: "En general, los IFC siempre se superponen a nubes de puntos visualizadas simultáneamente.",
        video_help: "En el visor 2D aparece una línea discontinua roja que muestra la ruta en la que se grabó el vídeo seleccionado. " +
          "En cuanto haces clic en la línea, el vídeo se inicia en un nuevo contenedor.",
        ki_help: "Al subir datos para ser procesados en X2BIM, se puede activar la detección de objetos LST. " +
          "Los resultados de la detección se muestran en el mapa junto a la correspondiente imagen ortográfica.",
        annotation_help: "Las anotaciones se pueden crear a partir de mediciones de distancia, mediciones de área y marcadores puntuales. " +
          "Primero se deben posicionar utilizando la barra de herramientas en la parte inferior.<hr />" +
          "A través del menú de medición, se puede crear la anotación. " +
          "Por ahora, <b>esto solo es posible si la medición se realiza sobre una imagen ortográfica</b>. " +
          "La anotación permanecerá temporalmente en el menú de anotaciones.<hr />" +
          'Para conservar permanentemente use el botón "Guardar" que aparece al desplegar la anotación.',
        search: "Buscar",
        share: "Compartir",
        clear: "Reiniciar visor",
        defaultSettings: "Standardeinstellungen",
        help: "Ayuda",
        container: "Gestión de vistas",
        account: "Cuenta",
        screenshot: "Captura de pantalla",
        project_loading: "Cargando el proyecto..",
        cancel_loading: "Cancelar carga",
        expand_settings: "Mostrar configuración",
        compare: "Comparar",
        close_compare: "cerrar comparar",
        no_openlayers: "Ningún mapa/contenedor 2D activo",
        too_many_openlayers: "El modo de comparación sólo puede estar activo en un mapa 2D. Seleccione el mapa 2D deseado.",
        too_many_containers: "Hay más de un contenedor abierto. Se recomienda cerrar todos los demás contenedores para el modo de comparación.",
        remove_containers: "Cerrar otros contenedores",
        keep_containers: "Mantener otros contenedores",
        cancel: "Cancelar",
        no_process: "Ningún proceso activo",
        linkcopied: "Enlace copiado",
        download_option: "Seleccione la opción de descarga",
        no_settings_found: "No se encontraron configuraciones",
        enabled: "Habilitado",
        default: "Predeterminado",
        last_modified: "Última modificación",
        add_new_setting: "Agregar nueva configuración",
        edit_setting: "Editar configuración",
        setting_name: "Nombre de la configuración",
        set_default: "Establecer como predeterminado",
        set_enabled: "Habilitar configuración",
        save: "Guardar",
        cancel: "Cancelar"
      },

      //2D Container
      openLayers: {
        basePoint: "punto base",
        left: "IZQUIERDA",
        right: "DERECHA",
        on_axis: "SOBRE EL EJE",
        noVideos: "No se han encontrado vídeos para este proceso",
        volumesOnly: "Sólo se pueden calcular volúmenes en DEMs y ortoimágenes",
        pointNoLongerOnProcess: "El punto modificado ya no se encuentra en un DEM u ortoimagen",
        errorVolumeCalculation: "Error al calcular el volumen",
        errorVolumeDifference: "La diferencia de volumen sólo puede medirse en DEMs u ortoimágenes. En ambos lados del modo de comparación deben estar activos dos DEMs u ortoimágenes diferentes",
        noProcess: "No se ha detectado ningún proceso",
      },

      //Potree Cotainer
      potree: {
        cancelTransmission: "Al menos un punto de la medición no se puede transmitir ya que su ubicación no está dentro de la nube de puntos. Se cancela la transmisión",
        threeDMeasurementNotPossible: "Las mediciones en 3D no están disponibles en su dispositivo",
        polygonsInThreeD: "Los polígonos de los datos de la vía solo se pueden mostrar en el visor 3D si todos los puntos del polígono se encuentran dentro de una nube de puntos.",
        removeProfile: "Para que se muestre un perfil, debe estar activo en un visor 3D. Si elimina el perfil de este visor 3D, se cerrará también el visor de perfiles actualmente abierto. ¿Desea continuar?",
      },

      // Dropdowns
      dd: {
        pin_dropdown: "Fijar el menú desplegable",
        show_info: "Informaciones",
        show_settings: "Ajustes",
        show_filter: "Opciones de filtro",
        search: "Buscar recursos",
        search_placeholder: "Fecha | Título | Descripción | Tags",
      },

      // Geo data (old base map) menu
      base: {
        basemap: "Mapa base",
        grayscale: "Escala de grises",
        terrain: "Topografía",
        satellite: "Satélite",
        hectometer: "Puntos hectométricos",
        ivl: "IVL",
        openrailwaymap_infra: "OpenRailMap (infrastructure)",
        openrailwaymap_signal: "OpenRailMap (LST)",
        process_clusters: "Clusters de procesos",
        ivl_plans_west: "IVL planos",
        active: "activo",
        inactive: "inactivo",
        signals: "Señales",
        increasezoom: "¡Aumentar Zoom!",
        decreasezoom: "¡Disminuir Zoom!",
        nobasemapwarn: "La configuración de datos geográficos solo está disponible con un mapa abierto",
        still_active_header: "No se puede desactivar",
        still_active_content: "Los geodatos siguen activos en al menos un contenedor 3D. " +
          "Para poder desactivarlos en el mapa, primero hay que desactivarlos en todos los contenedores 3D. " +
          "¿Deben eliminarse los geodatos de todos los contenedores 3D?",
        not_active_header: "No se puede activar",
        not_active_content: "Los geodatos no están activos en el mapa. " +
          "Para poder activarlos en un contenedor 3D, primero hay que activarlos en el mapa. " +
          "¿Deben activarse los geodatos en el mapa?",
        clearMapHeader: "¿Quieres reiniciar el visor?",
        clearMapPopupMessage: "Esta acción eliminará el progreso no guardado y reiniciará el visor. Haga clic en Sí para continuar.",
      },

      // Process menus (Ortho, Pläne, DGMs, Punktwolken)
      process: {
        toggle_single: "Solo",
        toggle_time: "Espacio de tiempo",
        toggle_download: "Descargar",
        filter: "Filtrar...",
        download: "Descargar recursos activos",
        deselect: "Deshacer selección",
        dgm: "ELEVACIÓN",
        dom: "SUPERFICIE",
        geo_inspect: "Geoinspector",
        uploads_from: "Subidas desde {{date}}",
        feb_2023: "02/2023",
        images: "Imágenes",
        remove: "Remover {{geo_inspect}}",
        activate_all: "Activar todos los procesos",
        activate_all_extent: "Activar todos los procesos de la sección",
        deactivate_all: "Desactivar todos los procesos",
        open_viewer: "Abrir {{viewer}}",
        viewer_2d: "Visor 2D",
        viewer_3d: "Visor 3D",
        time_plans: "Espacio de tiempo no está disponible para planos.",
        visible_processes: "Procesos", //         visible_processes: "Procesos visibles",
        timespan: "Espacio de tiempo",
        days: "Días",
        scanner: "Escaner",
        processes: "Procesos",
        percent: "{{value}}%",
        top: "Arriba",
        left: "Izquierda",
        right: "Derecha",
        collapse: "Ocultar recursos individuales de este grupo",
        expand: "Mostrar recursos individuales de este grupo",
        details: "Registrar información sobre recursos",
        copyUrl: "Copiar URL de la nube de puntos al portapapeles",
        color: "Colorear la nube de puntos",
        color_all: "Colorear todas las nubes de puntos activas de este grupo",
        elevation: "Colorear la nube de puntos en función de la altura",
        elevation_all: "Colorear todas las nubes de puntos activas de este grupo en función de la altura",
        settingAll: "Propiedades de visualización",
        resetAttributes: "Restablecer coloración",
        inspect: "Inspección de esta ortoimagen",
        inspect_all: "Inspección de todas las ortoimágenes activas de este grupo",
        external_viewer: "Ext. Visor",
        tagAktiv: "mostrar solo etiquetas activadas",
        link_types: "Carga conjunta de {{- types}}",
        ortho_pointcloud: "orto/nube de puntos",
        pointcloud_panorama: "nube de puntos/panorámicas",
        pointcloud_eyedom: "Sombreado",
        pointcloud_elevation: "Altura",
        pointcloud_elevationRepeat: "Elevation",
        pointcloud_elevationMin: "Reference height",
        pointcloud_elevationInterval: "Intervall",
        pointcloud_elevationRange: "Intervalo de altura",
        pointcloud_color: "Color",
        pointcloud_colorClass: "Colores de clasificación",
        pointcloud_intensity: "Intensidad",
        pointcloud_intensityGradient: "Intensidad Gradient",
        pointcloud_intensityRange: "Intervalo de intensidad",
        pointcloud_RGBAGamma: "Gamma",
        pointcloud_RGBABrightness: "Brillo",
        pointcloud_RGBAContrast: "Contraste",
        pointcloud_intesityGradiantGamma: "Gamma",
        pointcloud_intesityGradiantBrightness: "Brillo",
        pointcloud_intesityGradiantContrast: "Contraste",
        pointcloud_reset: "Zurücksetzen",
        filterText: "por hora, nombre o etiqueta",
        timestart: "desde",
        timeend: "hasta",
        includes: "contiene",
        showmodel: "Mostrar modelo",
        showwireframe: "Mostrar wireframe",
        settings: "configuración",
        autoload: "Recargar recursos automáticamente",
        process_clusters: "Visualizar clusters de procesos",
        sortby_date: "Fecha",
        sortby_title: "Título",
        sortby_description: "Descripción",
        alloff: "Apagar todos",
        transparency: "Transparencia",
        opacity: "Opacidad",
        max_points: "Máximo {{count}} Puntos",
        point_size: "Tamaño de puntos",
        small: "Pequeño",
        large: "Gran",
        point_budget: "Densidad de puntos",
        low: "Baja",
        high: "Alta",
        filter_type: "Tipo",
        filter_extent: "Sección del mapa",
        filter_extent_help: "Cuando está activada, sólo se muestran los recursos visibles en la sección actual del mapa",
        filter_date: "Fecha",
        filter_tag: "Tag",
        filter_type_drone: "Vuelo de multicóptero",
        filter_type_helicopter: "Vuelo de helicóptero",
        filter_type_video: "Video2BIM",
        filter_type_train: "Inspección del tren MSP",
        filter_type_cad: "Plan",
        filter_type_null: "Otros",
        open_calendar: "Abrir selección de calendario",
        reset_filters: "Restablecer filtro",
        resources_filtered: "Filtro: se muestran {{filtered}} de {{total}} recursos",
        no_resources_filtered: "No hay recursos coincidentes para estos ajustes de filtro",
        no_date: "Sin fecha",
        no_title: "Sin título",
        no_description: "Sin descripción",
        resource_count: "{{count}} recursos",
        new_3d: "Nuevo visor 3D",
        new_2d: "Nueva mapa 2D",
      },

      // KI menu
      ki: {
        pzb_magnet: "Imanes PZB",
        mast: "Señales",
        ai_objects: "Objetos de IA",
        overview: "Visión general",
        track_data: "Datos de pista",
        Strecken: "Pistas",
        Objekte: "Objetos",
        WMS: "Servicios WMS (Experimental)",
      },

      // Annotations menu
      annot: {
        not_available: "No disponible",
        archived: "ARCHIVADA",
        viewer_2d: "Visor 2D",
        viewer_3d: "Visor 3D",
        save: "Guardar",
        archive: "Archivar",
        download: "Descargar como JSON",
        title: "Título",
        flight: "Número de vuelo",
        dimension: "Dimensión",
        trade: "Sector",
        edit: "Editar",
        saved: "Guardado",
        unsaved: "No guardado",
        created: "Creado",
        changed: "Último cambio",
        description: "Descripción",
        unsaved_tooltip: "no guardado ({{value}})",
        unsaved_name: "Anotación de {{meastype}} no guardada",
        header: "Crear anotación",
        process_found: 'Proceso del tipo "{{processtype}}" encontrado',
        no_process: "No se ha encontrado ningún proceso asociado.",
        with: "Referirse al proceso",
        without: "Sin referencia al proceso",
        create: "Nueva Anotación",
        extend: "Ampliar anotación",
        save_first: "Guarde primero la anotación",
        selected: "seleccionado",
        create_button: "Crear anotación",
        extend_button: "Ampliar anotación(es)",
        meastypes: {
          distance: "distancia",
          area: "área",
          volume: "volumen",
          volume_delta: "diferencia de volumen",
          marker: "marcador",
          angle: "ángulo",
          height: "diferencia de altura",
          profile: "perfil",
          kilometrierung: "kilometraje",
          kilometrierung_distance: "eje kilometrado",
          gleisachse_distance: "eje de la vía",
          gleisachse_gap: "eje de la vía",
          inspect: "inspección geográfica",
          inspect_active: "inspección geográfica",
          tile_inspect: "inspección de procesos",
          gnd_inspect: "inspección de objectos",
        },
        processtypes: {
          ortho: "Ortográfica",
          plan: "Plano",
          dgm: "Terreno",
        },
        trades: {
          "Brandschutz": "Protección contra incendios",
          "KIB/Oberbau": "Ingeniería de vías",
          "LST": "Sistema de señales",
          "MTA": "Equipos mecánicos",
          "OLA": "Sistema de catenarias",
          "50 Hz": "50 Hz",
          "SiGeKo": "Coordinación de seguridad",
          "SÜ": "Supervisión de la vías",
          "TK": "Telecomunicaciones",
          "Sonstiges": "Otros",
          "Übergreifend": "General",
        },
        alerts: {
          invalid_trade: "Por favor elija un sector válido.",
          error_sending: "Se produjo un error al enviar los datos de anotaciones al servidor.",
          error_connection: "Hay un problema de conexión con la base de datos de anotaciones.",
          unsaved_header: "Anotación no guardada",
          unsaved_text: "Ya existe una anotación no guardada. ¿Debería sobrescribirse con la nueva anotación?",
          added_geom: "Geometría añadida.",
          only_2d: "Actualmente, sólo se pueden crear anotaciones en 2D. Por favor, transfiera la medición 3D al mapa si es necesario.",
        },
      },

      // Search menu
      search: {
        search: "Buscar",
        kilometry: "Kilometría",
        show_km: "Mostrar {{km}}",
        show: "Mostrar",
        coordinates: "Coordinadas",
        epsg: "EPSG",
        processes: "Procesos",
        projects: "Proyectos",
        places: "Lugares",
        ivl: "IVL",
        search_history: "Historial de búsqueda",
        search_for: "Ejemplos de búsqueda...",
        places_example: "'Hamburgo' / 'Berlin' / 'Mainz'",
        coordinates_example: "'13.4 52.5'",
        epsg_example: "DBREF/WebMerc/WGS84",
        kilometry_example: "'6362' / '6362 50,5'",
      },

      // Functionalities
      func: {
        lstdetected: "Objetos reconocidos",
        connectedimages: "Imágenes relacionadas",
        showimages: "Mostrar imágenes",
        hideimages: "Ocultar imágenes",
        multiple_gnd: "Varias capas de objetos encontradas",
        km: "Eje kilometrado",
        tr: "Eje de la vía",
        hm: "Punto hectométrico",
        obj: "Objeto",

        geometry: "Geometría",
        lineNumber: "Número de línea",
        directionIndicator: "Indicador de dirección",
        km: "Kilometraje",
        fromKm: "Kilometraje",
        toKm: "Kilometraje",
        label: "Etiqueta",

        Point: "Punto",
        MultiPoint: "Punto",
        LineString: "Línea",
        MultiLineString: "Línea",
        Polygon: "Polígono",
        MultiPolygon: "Polígono",
      },

      // Share menu
      share: {
        copy_link: "Copiar enlace",
      },

      // Container management menu
      container: {
        switch_to: "Cambiar a {{view}}",
        column: "Vista por columnas",
        row: "Vista por filas",
        auto_view_connect: "Sincronizar nuevos contenedores",
        sync_rotation: "Sincronizar la rotación",
        sync_zoom: "Sincronizar el zoom",
        content_2d: "Visor 2D",
        content_OPENLAYERS: "Visor 2D",
        content_INSPECT: "Geo Inspeccionar",
        content_PROFILE: "perfil",
        content_3d: "Visor 3D",
        content_POTREE: "Visor 3D",
        content_VIDEO: "Vídeo",
        remove: "Remover",
        move: "Mover contenedor",
        add_2d: "+2D",
        add_3d: "+3D",
      },

      // Toolbar
      tb: {
        distance_title: "Medir distancia",
        area_title: "Medir área",
        volume_title: "Medir volumen",
        volume_delta_title: "Medir diferencia de volumen",
        marker_title: "Marcar",
        angle_title: "Medir ángulo",
        height_title: "Medir diferencia de altura",
        profile_title: "Perfiles",
        kilometrierung_title: "Determinar kilometraje",
        kilometrierung_distance_title: "Medir sobre el eje kilometrado",
        gleisachse_distance_title: "Medir sobre la vía",
        gleisachse_gap_title: "Distancia al eje de la vía",
        inspect_title: "Inspección geográfica",
        inspect_active_title: "Inspección geográfica",
        tile_inspect_title: "Inspección de procesos",
        gnd_inspect_title: "Inspección de objectos",
        distance_help: "Establecer puntos haciendo clic izquierdo. No se establecerá ningún punto adicional al finalizar la medición.",
        area_help: "Establecer vértices haciendo clic izquierdo. No se establecerá ningún punto adicional al finalizar la medición.",
        volume_help: "Establecer área base haciendo clic izquierdo. No se establecerá ningún punto adicional al finalizar la medición. " +
          "Para realizar el cálculo del volumen en utiliza el modelo de elevación de terreno asociado a la imagen ortográfica. " +
          "Esto puede tardar un momento.",
        volume_delta_help: "Establecer área base haciendo clic izquierdo. No se establecerá ningún punto adicional al finalizar la medición. " +
          "Para realizar el cálculo de la diferencia del volumen en utiliza los modelos de elevación de terreno asociado a las imagenes ortográficas. " +
          "Esto puede tardar un momento. " +
          "Para utilizar esta herramienta, debe estar activado el modo de comparación.",
        marker_help: "Establecer marcadores haciendo clic izquierdo. No se establecerá ningún punto adicional al finalizar la medición.",
        angle_help: "Establezca un total de tres puntos haciendo clic. El resultado son dos rectas que se cruzan en el segundo punto. Se mide el ángulo entre las rectas.",
        height_help: "Establecer puntos de medición haciendo clic izquierdo. No se establecerá ningún punto adicional al finalizar la medición.",
        profile_help: "Establecer puntos haciendo clic izquierdo. No se establecerá ningún punto adicional al finalizar la medición. " +
          "Para realizar el cálculo del perfil en utiliza una nube de puntos asociado.",
        kilometrierung_help: "Seleccione una de las líneas de kilometraje visibles y termine la medición del kilometraje haciendo clic izquierdo. " +
          "Para hacer otra medición seleccione nuevamenete una de las líneas de kilometraje visibles.",
        kilometrierung_distance_help: "Seleccione una de las líneas de kilometraje visibles y luego elija un punto base. " +
          "Mida la línea de kilometraje desde el punto base seleccionado.",
        gleisachse_distance_help: "Seleccione uno de los bordes de vía visibles y elija un punto base. " +
          "Mida el borde de la vía desde el punto base seleccionando.",
        profile_along_axis_title: "Perfil a lo largo del eje",
        profile_perpendicular_title: "Perfil perpendicular al eje",
        axis_measurement_value: "Medición de eje",
        axis_line_number: "Línea",
        gleisachse_gap_2d_help: "Primero seleccione uno de los ejes de vía cargados y calibre la desviación: coloque los carriles guía verdes sobre los carriles de la ortofoto y haga clic. Cada clic mide entonces la distancia al eje de vía calibrado.",
        gleisachse_gap_3d_help: "Primero seleccione uno de los ejes de vía cargados. Cada clic mide entonces la distancia del punto al eje de vía.",
        gleisachse_gap_help: "Seleccione uno de los bordes de la vía y calibre el desvío. " +
          "Seleccione nuevamente el eje de la vía y mida en función del desvío calibrado anteriormente.",
        /* inspect_help: "Am ausgewählten Punkt werden alle verfügbaren Bilder der aktivierten Prozesse angezeigt. " +
          "Durch Klicken auf diese Bildsymbole öffnet sich das Inspect-Fenster.",
        inspect_active_help: "Am ausgewählten Punkt werden alle verfügbaren Bilder aller verfügbaren Prozesse angezeigt. " +
          "Durch Klicken auf die Bildsymbole öffnet sich das Inspect-Fenster.",
        tile_inspect_help: "Für den ausgewählten Punkt wird der sichtbare Prozess anzeigt.", TODO */
        gnd_inspect_help: "Al hacer clic en Objetos, se abre una ventana Inspeccionar. " +
          "Para utilizar esta herramienta, al menos una capa de objetos debe estar activa en el mapa.",
        edit_help: "Edite la medida arrastrando y soltando los puntos de las esquinas. " +
          "Los cambios se transfieren automáticamente a otros visores una vez finalizada la edición.",
        abort_changes: "Descartar cambios",
        apply_changes: "Aplicar cambios",
        no_measurements: "No existen mediciones en este proyecto.",
        menu: "Menú",
        base: "Funciones básicas",
        point: "Marca",
        height: "Medir altura",
        axis: "Medir eje",
        inspect: "Inspección",
        active_measurement: "Medición activa",
        finish_measurement: "Finalizar medición",
        finish_measurement_click: "Clic derecho para finalizar la medición",
        annotation_name: "TEMPORAL: {{measurement}}",
        annotation_status: "activa",
        annotation_text: "Descripción",
        show: "Mostrar {{profile_name}}",
        hide: "Ocultar {{profile_name}}",
        active: "activo",
        process_title: "Título del proceso",
        process_description: "Descripción",
        create_annotation: "Crear anotación",
        edit_measurement: "Editar medición",
        delete_measurement: "Eliminar medición",
        /* process_detected: "Detected Process",
        no_process: "No data is activated here",
        date: "Date",
        process_id: "Process ID",
        process_type: "Process Type", TODO */
        alerts: {
          coming_soon: "Disponible próximamente.",
          wrong_container: "Las anotaciones solo se pueden crear a partir de mediciones generadas sobre imágenes ortográficas o transferidas a imágenes ortográficas.",
          too_many_points: "Actualmente, las mediciones solo mediciones con un máximo de 16 vércices puede ser convertidas en anotaciones. Por favor, cree una nueva medición.",
          no_ortho: "Para crear una anotación, la medición debe estar asociada a un imagen ortográfica.",
          need_compare: "Para utilizar esta herramienta es necesario activar la función de comparación. " +
            "Haga clic derecho para salir.",
          need_gnd: "Para utilizar esta herramienta, al menos una capa de objetos debe estar activa en el mapa. " +
            "Haga clic derecho para salir.",
          need_ortho: "Para utilizar la función de geoinspección, debe haber al menos una ortofoto activa.",
          need_2d: "Esta herramienta sólo puede utilizarse en un mapa. " +
            "Haga clic derecho para salir.",
          need_3d: "Esta herramienta sólo puede utilizarse en una nube de puntos. " +
            "Haga clic derecho para salir.",
          measurement_not_in_container: "La medición seleccionada para editar se encuentra en otro visor.",
          measuring_in_other_container: "Ya estás trabajando en otro visor. " +
            "Haga clic derecho para salir.",
          editing_in_other_container: "Ya estás trabajando en otro visor.",
        }
      },

      // Info Container
      ic: {
        collapse: "Contraer contenedor de información",
        expand: "Expandir contenedor de información",
        rotate_north: "Alinear mapa al norte",
        rotate_45: "Rotar mapa 45°",
        hide_view_cone: "Campos de visión 3D visibles",
        show_view_cone: "Campos de visión 3D ocultos",
        stop_axis_navigation: "Finalizar la navegación en el eje",
        start_axis_navigation: "Iniciar la navegación en el eje",
        select_axis: "Seleccione el eje de la vía",
        cancel: "Cancelar",
        forward: "Adelante [(Ctrl+)(⇧+) X]",
        backward: "Atrás [(Ctrl+)(⇧+) Y]",
        change_direction: "Cambiar la dirección",
        next_pano: "↑ [.]",
        prev_pano: "↓ [,]",
        decouple: "Vista sincronizada",
        couple: "Vista no sincronizada",
        log_measurements: "Registrar mediciones",
        log_map: "Registrar mapa",
        leave: "Salir de la vista panoamica",
        hide: "nubes de puntos visibles",
        show: "nubes de puntos ocultas",
        log_viewer: "Registrar visor",
        orbit: 'Configuración de cámara "Modo Órbita"\n' +
          "Rotación alrededor del punto de enfoque\n" +
          "Movimiento en el plano de la cámara",
        earth: 'Configuración de cámara "Modo Earth"\n' +
          "Rotación alrededor del punto de clic\n" +
          "Movimiento en el plano del suelo",
        ego: 'Configuración de cámara "First-Person"\n' +
          "Rotación alrededor de la posición de la cámara\n" +
          "Movimiento en el plano de la cámara\n" +
          "- horizontalmente: teclas de flecha\n" +
          "- verticalmente: Av Pág / Re Pág",
        top_down: 'Vista superior',
        down_top: 'Vista inferior',
        side_front: 'Vista frontal',
        side_back: 'Vista trasera',
        side_left: 'Vista izquierda',
        side_right: 'Vista derecha',
        profile: "Perfil {{name}}",
        brightness: 'Brillo',
        intensity: 'Intensidad',
        reset: "Restablecer altura",
        syncall: "Sincronizar todos los movimientos",
        synctransl: "Sincronizar traslación/movimiento",
        syncrot: "Sincronizar rotación",
        synczoom: "Sincronizar zoom",
      },
    },

    support: {
      supportTittle: "Soporte",
      supportIntro: "Si tiene alguna pregunta o algún problema, consulte primero el <0>X2BIM Wiki</0> <1>X2bim CMS</1>. Allí encontrará información útil, instrucciones y respuestas a las preguntas más frecuentes.",
      supportContact: "Si tiene preguntas técnicas o especializadas, por ejemplo, sobre autorizaciones o aprobaciones de proyectos, póngase en contacto con el siguiente punto de atención: <0>{{email}}</0>",
      supportGeneral: "Para consultas generales sobre X2BIM, utilice el siguiente formulario. Por favor, describa su preocupación para que podamos encontrar una solución de manera oportuna. Para ello, utilice también archivos adjuntos (PNG, JPG o PDF).",
      message: "Mensaje al equipo de soporte de X2BIM.",
      close: "Cerrar",
      send: "Enviar",
      addFileTittle: "Agregar archivos",
      sent: "Enviada",
      failed: "No se pudo enviar el mensaje",
    },

    changelogs: {
      title: "News"
    },

    customerSettings: {
      title: "Ajustes",
      geoServices: {
        title: "Servicios Geo Externos",
        add: "Añadir",
        empty: "No hay servicios geo externos disponibles.",
        createTitle: "Crear Servicio Geo",
        editTitle: "Editar Servicio Geo",
        deleteTitle: "Eliminar Servicio Geo",
        deleteConfirm: "¿Está seguro de que desea eliminar este servicio geo?",
        nameLabel: "Nombre",
        urlLabel: "URL",
        save: "Guardar",
        cancel: "Cancelar",
        delete: "Eliminar",
        validationError: "El nombre y la URL son obligatorios.",
        configValidationError: "El campo \"{{field}}\" es obligatorio.",
        typeLabel: "Tipo",
        configSection: "Configuración",
        getCapabilities: "Obtener capacidades",
        capabilitiesHint: "Introduzca la URL y haga clic en 'Obtener capacidades' para cargar las opciones de configuración.",
        capabilitiesSuccess: "Conexión exitosa. Las opciones de configuración han sido cargadas.",
        capsFailed: "GetCapabilities falló",
        capsCorsFailed: "Conexión fallida. El servidor puede no permitir solicitudes de origen cruzado (CORS).",
        config: {
          layers: "Capas",
          layer: "Capa",
          format: "Formato",
          version: "Versión",
          projection: "Proyección",
          matrixSet: "MatrixSet",
          tmsY: "Eje Y TMS (Y=0 abajo, invertido)",
        },
      },
    },

    leftNav: {
      dashboard: "Controles",
      viewer: "Visor",
      labeling3d: "3D-Labeling",
      sbb: "Clearance Inspector",
      betaViewer: "MapLibre Viewer",
      uploader: "Cargar Datos",
      projects: "Proyecto",
      processes: "Procesos",
      tools: "Tools",
      management: "Management",
      userManagement: "Usuarios",
      language: "Idioma",
      help: "Ayuda",
      faq: "FAQ",
      wiki: "Wiki",
      logout: "Cerrar sesión",
      account: "Cuenta",
      userManual: "manual de usuario",
      support: "Apoyo",
      credit: "Controlling",
      finance: "Control iV",
      bim: "BIM Viewer",
      nextgen: "NextGen",
      customerSettings: "Ajustes",
    },

    accountSettings: {
      title: "Configuración de usuario",
      userName: "Nombre de usuario",
      role: "Rol",
      communicationEmail: "Dirección de correo de contacto",
      change: "Cambiar",
      save: "Guardar",
      cancel: "Cancelar",
      close: "Cerrar",
      invalidEmail: "Introduzca una dirección de correo válida",
      emailUpdated: "Dirección de correo de contacto actualizada",
      emailUpdateFailed: "No se pudo actualizar la dirección de correo de contacto",
      emailNotConfirmed: "Esta dirección de correo aún no ha sido confirmada.",
      newsletter: "Recibir boletín/actualizaciones",
      newsletterUpdated: "Preferencia del boletín actualizada",
      newsletterUpdateFailed: "No se pudo actualizar la preferencia del boletín",
      deleteAccount: "Eliminar cuenta",
      deleteConfirm: "¿Desea solicitar la eliminación de su cuenta? Nuestro equipo de soporte se pondrá en contacto con usted.",
      deleteRequested: "Solicitud de eliminación enviada",
      deleteFailed: "No se pudo enviar la solicitud de eliminación",
    },

    dashboard: {
      yourProject: "Tus proyectos ({{count}})",
      overview: "Dashboard",
      noCustomerWarning: "Aún no se le ha asignado ningún cliente. Póngase en contacto con su administrador.",
      noLinkedCustomer: "Sin cliente vinculado",
      noProjectWarning: "¡No hay proyectos asignados! ¡Por favor, contacta al equipo!",
      search: "Buscar",
      projectCard: {
        processes: "Procesos",
        showAll: "Mostrar todo"
      },
      table: {
        search: "Buscar",
        projectTitle: "Título del proyecto",
        processCount: "Cantidad de procesos",
        epsg: "EPSG",
        openInApp: "Abrir en la aplicación"
      },
      apps: {
        viewer: "Visor",
        uploader: "Subir archivos",
        projects: "Proyectos",
        processes: "Procesos"
      },
      jumpTo: "Ir a",
      pd: {
        selectionNeeded: "Por favor, seleccione primero un proyecto",
        deleteModalContent: "¿Quiere eliminar el proyecto seleccionado y todos los datos relacionados? Esta acción no se puede deshacer.",
        update: "Actualisar",
        discard: "Desechar cambios",
        selection: "Proyecto seleccionado",
        create: "Crear",
        noProjectCreated: "No se pudo crear el proyecto",
        noProjectUpdated: "No se pudo actualizar el proyecto",
        details: "Información",
        groupTitles: {
          generalInfo: "Información general",
          controllingMetadata: "Metadatos de gestión",
          dataViewer: "Visor de datos"
        },
        administration: {
          title: "Administración",
          processesText: "procesos subidos",
          usersText: "usuarios añadidos"
        },
        boundary: "Límites",
        processeCopy:  "Copiar",
        defaultViewer: "Visor predeterminado",
        viewerSettings: {
          title: "Visor configuraciónes",
          discontinuedWarning: "Advertencia: La optimización de procesos está obsoleta y se eliminará en el futuro.",
          processSortings: {
            title: "Ordenación de procesos",
            description: "Establece la ordenación por defecto de los procesos visibles en el visor",
            selectedType: "Tipo seleccionado",
            resetAll: "Restablecer todo por defecto",
            sortBy: "Ordenar por",
            resetSelected: "Restablecer seleccionado por defecto"
          }
        },
        pboundary: "{{- projectName}} Límites",
        userAccess: "Permisos de proyecto",
        pgnd: "{{- projectName}} GIS/Vías",
        createProject: "Crear proyecto",
        projects: "Proyectos",
        projectSelection: "Selección de proyecto",
        projectUAcess: "Permisos de proyecto {{- projectName}}",
        projectProcess: " Procesos {{- projectName}}",
        projectProcessAccess: "Permisos de procesos {{- projectName}}",
        openProject: "Abrir",
        newProject: "Crear proyecto",
        uploadProjectImage: "Cargar imagen del proyecto",
        projectCreateMessage: "Proyecto creado",
        projectName: "Nombre del proyecto",
        logoUploaded: "Logotipo del proyecto cargado",
        logoLoaded: "Logotipo cargado",
        customerName: "Nombre del cliente",
        projCode: "Código del proyecto",
        projDuration: "Duración del proyecto",
        years: "Años",
        desc: "Descripción del proyecto",
        coord: "Sistema de coordenadas del proyecto",
        accountAllocation: "Asignación de cuenta",
        fromCreditBalance: "del saldo de créditos",
        plannedCredit: "Créditos planificados",
        dataOwner: "Propietario de los datos",
        mmSize: "Tamaño de mapa móvil",
        pcSize: "Tamaño de nube de puntos",
        heliSize: "Tamaño de datos de helicóptero",
        flightArea: "Área de vuelo",
        gigaPixel: "GigaPixel",
        uploadKML: "Cargar KML",
        addKML: "Añadir KML",
        or: "O",
        save: "Guardar",
        delete: "Delete",
        uploadKMLTitle: "Cargar proyecto KML",
        dragFile: "Arrastre el archivo aquí",
        fileExplorer: "Abra el Explorador de archivos haciendo clic",
        userRemoved: "Usuario removido",
        userAdded: "Usuario agregado",
        addUser: "Añadir cuenta",
        addAccount: "Añadir cuenta",
        editAccount: "Editar roles",
        inviteUser: "Usuario no encontrado",
        inviteOrProvisionUserMessage: "El usuario {{email}} no existe en la plataforma. Tiene dos opciones: puede provisionar el usuario temporalmente hasta que realice su primer inicio de sesión con un proveedor de identidad conocido, o puede enviarle una invitación para que se registre en el proveedor de identidad de x2bim.com.",
        provisionUserMessage: "El usuario {{email}} no existe en la plataforma. Puede provisionar el usuario temporalmente hasta que realice su primer inicio de sesión con su proveedor de identidad.",
        sendInvitation: "Enviar invitación",
        provisionUser: "Provisionar usuario",
        users: "Usuarios",
        roles: "Roles",
        add: "Añadir",
        cancel: "Cancelar",
        name: "Nombre",
        remove: "Remover",
        export: "Exportar",
        action: "Acción",
        removeWarning: "¿Estás seguro de que deseas eliminar el registro?",
        projectCreate: "Crear proyecto",
        projectDelete: "Eliminar proyecto",
        projectUpdate: "Update",
        gnd: "GIS/Vías",
        layers: "Layers",
        layerType: "Tipo de layer",
        editLayer: "Editar {{name}}",
        kilometerline: "Línea kilometrada",
        trackline: "Línea de vías",
        hectometerpoints: "Puntos hectométricos",
        trackdataDbigo: "Datos de red de vías DB IGO",
        kilometerLineSegment: "Tramos (kilometraje)",
        trackEdgeSegment: "Bordes de vía (posicionamiento)",
        miscellaneous: "Misceláneo",
        wms: "Servicios WMS (Experimental)",
        tracktopography: "SBB Tracktopography",
        addNewLayer: "Añadir un layer nuevo",
        Gleispunkte: "Track Points",
        tunnels: "Tunnel",
        tracks: "GTG-Strang-Namen",
        layerName: "Nombre del layer",
        unnamedLayer: "Layer sin nombre",
        layerColor: "Color del layer",
        layerDimensions: "Dimensiones del layer",
        invalidHexString: "String hexadeicmal inválido",
        uploadError: "Error inesperado. Vuelva a intentarlo más tarde o póngase en contacto con nosotros si el problema persiste.",
        layerDeleteMsg: "¿Está seguro de que desea eliminar este layer y todos los objetos a los que hace referencia?",
        edit: "Editar",
        noUploadsYet: "Parece que este layer aún no tiene cargas. Sé el primero en añadir una usando el signo más rojo.",
        createNewUpload: "Crear una caraga nueva",
        deleteUpload: "¿Está seguro de que desea eliminar esta carga de {{date}} y todos los objetos a los que hace referencia?",
        deleteUploadTitle: "Datos de GIS/vías cargados '{{ uploadToDelete }}'",
        correspondingUploadedData: "Datos de GIS/vías cargados",
        newUpload: "Nueva craga",
        forLayer: "para layer ",
        targetType: "Tipo objectivo",
        inputFileSelection: "Selección del archivo de entrada",
        selectFile: "Seleccionar un archivo",
        requiredEPSG: "EPSG obligatorio: 3857",
        requiredEPSGDbigo: "EPSG obligatorio: 4326",
        supportedGeometryTypes: "Tipos de geometría compatibles: ",
        jsonNoFeatures: "GeoJSON debe incluir al menos un feature",
        jsonMultipleTypes: "GeoJson se compone de múltiples tipos. Por ahora sólo se permiten colecciones de un solo tipo.",
        jsonUnsupportedType: `Tipo de geometría no compatible {{unsupportedType}} en GeoJSON. Asegúrese de utilizar una de las opciones Point o MultiLineString.`,
        gndAddTitle: "Añadir nuevos objetos",
        gndError: "No se ha podido guardar el layer. Vuelva a intentarlo más tarde..",
        gndSuccess: "Layer guardando con éxito. Ahora puede visualizarla manualmente en el visor.",
        gndSubmit: "Añadir objetor to layer",
        attributeMapping: "Asignación de atributos",
        gndPointType: "Tipo de Point",
        gndLineType: "Tipo de Line ",
        selectJson: "Seleccionar GeoJSON",
        gndNameKey: "Atributo Nombre",
        gndKmKey: "Atributo Km",
        gndLineKey: "Atributo Line-Number",
        gndTrackKey: "Atributo Track-Distinctive",
        gndKmStartKey: "Atributo Start-Km",
        gndKmEndKey: "Atributo End-Km",
        gndSimpleType: "Simple",
        gndKilometerizedType: "Kilometrado",
        gndGroups: "Grupos GND",
        manageGndGroups: "Administrar grupos gnd y su visibilidad",
        gndGroupsCreate: "Crear nuevo grupo GND",
        noGroups: "No hay grupos GND disponibles todavía.",
        noLayerGroups: "No hay grupo GND disponible.",
        layerGroupLabel: "Grupos GND",
        createFirstGroup: "Crear el primer grupo",
        additionalAttributes: "Más atributos",
        objectExport: "LRPO Export",
        deleteRoles: "¿Está seguro de que desea eliminar este usuario del cliente?",
      },
      processes: {
        selection: "Selección",
        processes: "Lista de procesos",
        userAccess: "Permisos de proceso",
        procArchived: "Proceso archivado",
        "procDeleted": "¡Eliminación del proceso activada! Esta operación puede tardar algún tiempo en finalizar.",
        procArchivedFailed: "Error al archivar el proceso",
        tableCompact: "Compacta",
        tableFull: "Completa",
        pID: "ID",
        pTitle: "Título del proceso",
        pDesc: "Descripción del proceso",
        pType: "Tipo de proceso",
        pStatus: "Estado del proceso",
        all: "Todos",
        allWithoutDeleted: "Todos excepto los eliminados",
        pSourceDate: "Fecha de origen",
        pInitDate: "Fecha del proceso",
        pTags: "Etiquetas",
        actions: "Acciones",
        actionsAdmin: "Acciones de admin",
        actionsEdit: "Editar",
        downloadReport: "Descargar informe",
        internal: "Interna",
        external: "Externa",
        standardUserAccess: "Usuario",
        grantStandardUserAccess: "Conceder acceso al usuario estándar",
        revokeStandardUserAccess: "Revocar acceso al usuario estándar",
        usedStorageMB: "Almacenamiento usado",
        creditsConsumed: "Créditos consumidos",
        usedStorageShort: "Almacenamiento",
        creditsConsumedShort: "Créditos",
        archive: "Eliminar",
        close: "Cerrar",
        addTagToProcess: "+ Añadir un tag al proceso",
        selectOrCreateTag: "Elegir or crear un tag",
        deleteProcessMsg: "Quieres eliminar este proceso?",
        areYouSure: "Estas seguro",
        confirmText: "¿Seguro que quieres {{status}} el acceso de usuario estándar en los {{count}} procesos seleccionados?",
        activate: "Activar seleccionado",
        deactivate: "Deshabilitar los seleccionados",
        enableAccess: "activar",
        disableAccess: "desactivar",
        accessPermissionMissing: "No tienes permiso para cambiar el acceso al proceso.",
        accessFinishedOnly: "El acceso solo se puede cambiar en procesos finalizados.",
        processAccessGranted: "Se concedió acceso de visualización para usuarios estándar al proceso '{{processTitle}}'.",
        processAccessRevoked: "Se revocó el acceso de visualización para usuarios estándar al proceso '{{processTitle}}'.",
        bulkProcessAccessGranted: "Se concedió acceso de visualización para usuarios estándar a {{count}} procesos seleccionados.",
        bulkProcessAccessRevoked: "Se revocó el acceso de visualización para usuarios estándar a {{count}} procesos seleccionados.",
        statusChanged: "Estado cambiado",
        copyId: "Copiar ID",
        idCopied: "ID copiado",
        copyText: "Proyecto: {{projectName}} - copiar a otro proyecto",
        reparseSensors: "Recrear sensores",
        reparseConfirmTitle: "¿Desea recrear los sensores?",
        reparseConfirmDescription: "Estos se crearán en base a los datos existentes del almacenamiento.",
      },
      objectExport: {
        warning: "Something went wrong while getting process details!!",
        confirm: "Please confirm",
        confirm_text: `This action will export {{count}} object(s). Please click the "Export" button
            below to confirm.`,
        export: "Export",
        heading: "Objektexport nach LIRA",
        text: 'Wählen Sie einzelne Befahrungen aus, um Objekte nach LIRA zu exportieren. Exportierbar sind Objekte im Status "geschlossen". Es werden Ihnen nur Befahrungen angezeigt, die mindestens ein geschlossenes Objekt beinhalten.',
        p_disc: "Beschreibung",
        date: "Datum",
        open: "offen",
        closed: "geschlossen",
        exported: "exportiert",
        exportSuccessMessage: `Export of {{count}} object(s) started. This will take a few minutes. If objects were exported successfully, they will be in the state “exported”.`,
        noItem: "Bisher gibt es noch keine Objekte zum Exportieren.",
      }
    },

    homePage: {
      dashboardLink: "Ir al Visor",
      platform: "Acerca de la plataforma",
      impressum: "aviso legal",
      datenschutz: "protección de datos",
      dataText: "Datos desde X perspectivas",
      point1: "Especializado en distancias largas y proyectos de gran escala",
      point2: "Anonimización conforme al RGPD utilizando IA",
      point3: "Inicio de sesión único empresarial (por ejemplo, M365)",
      point4: "Reconocimiento de objetos basado en visión por computadora y IA en 2D y 3D",
      point5: "Desarrollo de módulos de IA específicos para el cliente",
      point6: "Datos de imagen, ortoimágenes y nubes de puntos",
      point7: "Solución de alto rendimiento para el procesamiento de datos 2D/3D",
      point8: "Integración de modelos (IFC) y planos (DWG)",
      point9: "Datos UAV, Helicóptero, mapeo m'óvil y red de vías BIM",
      text1: "Medir en 3 dimensiones",
      text2: "Análisis de datos multitemporales",
      text3: "Eje de vía y funciones kilométricas",
      text4: "Visualización multidimensional",
      description: "Los proyectos de infraestructura modernos requieren soluciones innovadoras y nuevas perspectivas. " +
        "Con X2BIM como plataforma común para vuelos (UAS), datos de escaneo láser terrestre y mapeo móvil, no solo aumentará la eficiencia en el proyecto, sino que también obtendrá nuevas perspectivas en sus datos. " +
        "Compare sus planos CAD y modelos BIM con nubes de puntos en 3D o fotografías aéreas de alta resolución fácilmente en la web y supervise su sitio de construcción en tiempo real.",
      moreInfo: "Aprende más...",
    },

    //User Management
    um: {
      accounts: "User Accounts"
    },

    notify: {
      roleSuccess: "Roles guardados",
      invitationSent: "Invitación enviada con éxito",
      invitationFailed: "Error al enviar la invitación",
      provisionFailed: "Error al provisionar el usuario",
      addUserFailed: "Error al agregar el usuario",
      maxUsersReached: "Se ha alcanzado el número máximo de usuarios para este cliente",
      userAddedToCustomer: "Usuario agregado al cliente",
      rolesFailed: "Error al guardar reglas",
      userAlreadyInCustomer: "Este usuario ya pertenece al cliente. Para asignar roles adicionales, use la acción de edición en la tabla de usuarios.",
      noActiveProject: "¡No hay ningún proyecto activo!",
      confirm: "Por favor confirmar",
      confirmDeleteProjectMessage: "¿Estás seguro de que deseas eliminar este proyecto?",
      confirmAction: "Sí",
      cancel: "No",
    },

    messages: {
      loginErrorTittle: "¡Tu sesión ha expirado, por favor inicia sesión de nuevo!",
      loginError: "¡Debido a inactividad, esta sesión ha finalizado! Por favor, inicia sesión nuevamente para acceder a esta página.",
      login: "Iniciar sesión",
      logOut: "Cerrar sesión",
      pricingButton: "Planes",
      x2bimToInfraviewButton: "X2BIM a Infraview",
      requestADemoButton: "Solicite una Demostracion",
      agbsButton: 'ALB',
      notAllowed: "No permitido",
      notAllowedMessage: "¡No tienes acceso apropiado para visitar esta página!",
      goBack: "Regresar",
      apiError: "¡Error al conectar con el servidor! Inténtalo de nuevo en un momento.",
      tryAgain: "Intentar de nuevo",
      apiIssue: "Error en la solicitud con estado {{statusCode}}.",
      errorTittle: "¡La aplicación se ha topado con un problema! :(",
      progressSaved: "Progreso guardado",
      noActiveProject: "¡No hay ningún proyecto activo!",
      onlyPNG: "Solo se permiten imágenes en formato PNG para cargar. ¡Asegúrate de que el logo tenga el formato de archivo correcto!",
    },

    uploadModal: {
      dropFileHere: "Suelte el archivo aquí",
      clickOrDrop: "Haga clic para seleccionar o soltar el archivo aquí",
      selectFile: "Seleccionar archivo",
      parsingFailed: "Fallo en el análisis del archivo",
      acceptedFileTypes: "Tipos de archivo aceptados: ",
    },

    credit: {
      titleCustomer: "{{customer}}",
      titleCredits: "Créditos totales: {{credit}}",
      noActiveCustomer: "¡¡Ningún cliente activo!! ¡Elija un cliente del menú de la izquierda!",
      noTxns: "No hay detalles de la transacción disponibles",
      consumptionDetails: "Detalle de consumo por proyecto",
      noProjectWiseConsumption: "No hay detalles de consumo por proyecto disponibles",
      creditTxns: "Transacciones de crédito",
      creditTxnsAll: "Transacciones de crédito de todos clientes",
      balanceCustomers: "Equilibrio de crédito por cliente",
      txnDate: "Fecha de Transacción",
      creditIncome: "Ingresos crediticios",
      creditConsumed: "Créditos consumidos",
      txnStatus: "Estado",
      txnDescription: "Descripción",
      addedBy: "Usuario",
      open: "Abierta",
      close: "Cerrardo",
      project: "Proyecto",
      consumedBy: "Verbraucht durch",
      sum: "Suma",
      year: "Año",
      "January": "Enero",
      'February': "Febrero",
      'March': "Marzo",
      'April': "Abril",
      'May': "Mayo",
      'June': "Junio",
      'July': "Julio",
      'August': "Agosto",
      'September': "Septiembre",
      'October': "Octubre",
      'November': "Noviembre ",
      "December": "Diciembre",
      customerBalance: "Saldo de clientes",
      consumptionPerCustomer: "Consumos por Cliente",
      addTxn: "Add A Transaction",
      customer: "Cliente",
      addTxnButton: "Añadir transacción",
      add: "Añadir",
      change: "Cambie",
      customerId: "ID del cliente",
      txnType: "Tipo de transacción ID",
      amount: "Importe",
      desc: "Descripción",
      negativeTxn: "Transacciones negativas",
      positiveTxn: "Transacciones positivas",
      balance: "Equilibrio",
      CreditAdded: "Añadir crédito",
      CreditRemoved: "Eliminar crédito",
      credits: "Créditos",
      dateRange: "Rango de fechas",
      startDate: "Fecha de inicio",
      endDate: "Fecha final",
      apply: "Aplicar",
      trendcreditconsumption: "Tendencia de consumo de créditos",
      trendView: "Tendencia",
      monthlyStackView: "Pila mensual",
      dailyStackView: "Pila diaria",
      topCustomersView: "Clientes principales",
      creditConsumption: "Consumo de créditos",
      creditBalance: "Saldo de créditos",
      filters: "Filtros",
      allOption: "Todos",
      selectedCount: "{{count}} seleccionados",
      clearSelection: "Limpiar selección",
      dateFrom: "Desde",
      dateTo: "Hasta",
      creditConsumptionTrend: "Tendencia de consumo de créditos",
      accumulated: "Acumulado",
      aggregated: "Agregado",
      groupBy: "Agrupar por",
      groupByStatus: "Estado (Abierto/Cerrado)",
      timeWindow: "Ventana de tiempo",
      noDataAvailable: "No hay datos disponibles para los filtros seleccionados.",
      exportCsv: "Exportar CSV",
      collapseGroup: "Contraer grupo",
      expandGroup: "Expandir grupo",
      ivProjectId: "ID del proyecto iV",
      projectCode: "Código del proyecto",
      accountAllocation: "Asignación de cuenta",
      date: "Fecha",
      transactionType: "Tipo de transacción",
      processPID: "Proceso (PID)",
      processTitle: "Título del proceso",
      processId: "ID del proceso",
      processName: "Tipo de proceso",
      runningBalance: "Saldo en curso",
      errorLoading: "Error al cargar: {{message}}",
      infrastructure: "Infraestructura",
      transactionsCount_one: "{{count}} transacción",
      transactionsCount_other: "{{count}} transacciones",
    },

    notFound: {
      fourZeroFour: "404: Página no encontrada",
      helpMsg: "O has intentado alguna ruta sospechosa o has llegado aquí por error. Sea lo que sea, intenta utilizar la navegación",
      goBackToStart: "Volver al principio"
    },
    pricing: {
      mainTitle: 'Precios de X2BIM',
      included: 'Incluido',
      additionalUser: 'Usuario Adicional',
      includedCredits: 'Créditos Incluidos',
      creditCost: 'Costo por Credito',
      inclProcessAndHosting: '(Incl. Procesamiento y Alojamiento)',
      concurrProcessPipelines: 'Pipelines de Procesamiento Concurrente',
      tierButton: 'Comenzar',
      tier: 'Nivel',
      credits: 'Créditos',
      'Order Access': 'Acceso a pedidos',
      'Tools': 'Herramientas',
      'Updates': 'Actualizaciones',
      'Support': 'Soporte',
      'Unlimited Projects': 'Proyectos ilimitados',
      'SSO': 'Inicio de sesión único',
      'Unlimited Users*': 'Usuarios ilimitados*',
      table: {
        title: 'Tabla de X2BIM',
        header: ['Posición', 'Descripción', 'Unidad', 'Créditos por unidad'],
        content: [
          { position: '1', description: 'Datos UAV/Encuesta', unit: '1 GigaPixel (Gpix)', creditsPerUnit: '1000' },
          { position: '2', description: 'Nubes de puntos (incluidas imágenes panorámicas)', unit: '1 Gigabyte (GB)', creditsPerUnit: '200' },
          { position: '3', description: 'Costos generales de almacenamiento (por mes)*', unit: '1 Gigabyte (GB)', creditsPerUnit: '5' },
          { position: '4', description: 'Reconocimiento de objetos/IA *', unit: '-', creditsPerUnit: '-' },
          { position: '5', description: 'Importación de planos (Geotiff)', unit: 'por proceso', creditsPerUnit: '250' },
          { position: '6', description: 'Modelo IFC', unit: 'por proceso', creditsPerUnit: '250' },
          { position: '7', description: 'Configuración inicial de SSO**', unit: 'una vez', creditsPerUnit: '5000' },
        ]
      },
      calculator: {
        title: 'Ayuda con los calculos',
        subTitle: 'Calcula cuántos créditos adicionales por mes necesitas.',
        selectATier: 'Selecciona un nivel:',
        tiers: ['Básico', 'Avanzado', 'Empresarial'],
        noFlightsPerMonth: 'N.º de vuelos / mes',
        noPhotosPerFlight: 'N.º de fotos / vuelo',
        megapixels: 'Megapíxeles',
        creditsIncluded: 'Créditos incluidos en el nivel {{tier}}',
        creditsPerMonth: 'créditos/mes',
        extraCreditsPerMonth: 'Créditos adicionales necesarios por mes:',
        imageProcessing: {
          title: 'Calcula los créditos mensuales adicionales necesarios para tus necesidades de procesamiento de imágenes.',
        },
        pointCloudProcessing: {
          title: 'Calcula los créditos mensuales adicionales necesarios para tus necesidades de procesamiento de nubes de puntos.',
        }
      }
    },

    lrp: {
      resumeSurvey: {
        title: "¿Desea continuar trabajando en el último levantamiento?",
        openLastSurvey: "Abrir el último levantamiento",
        goToMap: "Ir al mapa",
        error: "No se pudo abrir el último levantamiento. Inténtelo de nuevo o vaya al mapa.",
      },
      profileInfo: {
        startMeasurement: "Iniciar medición",
        stopMeasurement: "Detener medición",
        showProfile: "Mostrar perfil",
        createObject: "Crear objeto",
        clearMeasurement: "Borrar medición",
      }
    },

    // BIM Viewer. The rest of this section is not translated into Spanish yet, so it falls back
    // through i18n.js's chain (de → en); these are the keys that have been done.
    bim: {
      tools: {
        cameraFrustums: "Estaciones de cámara",
        cameraFrustumsFocus: "Acercar a todas las cámaras",
        cameraFrustumImages: "Mostrar fotos en los planos de cámara",
        cameraFrustumCount: "{{count}} cámaras",
        cameraFrustumLoading: "Cargando cámaras…",
        cameraFrustumNone: "Ningún vuelo con fotos cargado",
        cameraFrustumFlights: "Vuelos",
        photoLookupPick: "Buscar fotos de un punto: haz clic en un lugar de la escena",
        photoLookupCount: "{{count}} fotos muestran este punto",
        photoLookupEmpty: "Ninguna foto muestra este punto",
        photoLookupHint: "Elige un punto en la escena para ver qué fotos lo muestran.",
        photoLookupClose: "Cerrar",
        cameraViewTitle: "Dentro de la foto · {{name}}",
        cameraViewHint: "Arrastra para mirar alrededor. Al alejarte saldrás de esta vista.",
        cameraViewOpacity: "Opacidad de la foto",
        cameraViewExit: "Salir",
        cameraViewPrevious: "Foto anterior",
        cameraViewNext: "Foto siguiente",
        panoramaViewTitle: "360° · {{name}}",
        panoramaViewHint: "Arrastre para mirar alrededor. Haga clic en el suelo para ir a un panorama cercano.",
        panoramaViewExit: "Salir",
        panoramaViewPrevious: "Panorama anterior",
        panoramaViewNext: "Panorama siguiente",
        panoramaViewOpacity: "Opacidad de la nube de puntos",
        panoramaViewColorAdjustments: "Ajustes de imagen",
        clipScene: "Recortar escena",
        clipDimensions: "Dimensiones",
        clipRotation: "Rotación",
        clipInvert: "Invertir recorte",
        clipGhostPersistent: "Mostrar siempre el contexto recortado",
        clipSlice: "Modo de corte",
        clipSliceAxis: "Eje",
        clipPosition: "Posición",
        clipThickness: "Grosor",
        clipPin: "Fijar panel",
        clipUnpin: "Soltar panel",
        clipFollowCamera: "La cámara sigue el corte",
        clipHandles: "Asas de caras y de rotación",
        clipViewAlong: "Vista a lo largo de {{axis}}",
        clipCloseProfile: "Cerrar perfil de alturas",
        clipOpenProfile: "Abrir perfil de alturas",
        clipOpenProfileUnavailable: "Los perfiles de alturas requieren un corte X o Y vertical y no invertido",
        profileWidth: "Ancho del perfil",
        profileOpenSlice: "Mostrar como corte 3D",
        profileOpenSliceUnavailable: "Los cortes 3D requieren una escena cargada",
        clipLinePicking: "Haga clic en un eje en la escena 3D … Esc u otro clic cancela",
        clipLineSelect: "Corte a lo largo de un eje – haga clic y seleccione el eje en la escena 3D",
        clipLineReady: "Iniciar el corte a lo largo del eje {{label}}",
        clipLineActive: "Corte a lo largo del eje {{label}} – haga clic para elegir otro eje",
        clipLineWidth: "Ancho",
        clipFitView: "Ajustar la caja a la vista actual",
        clipFitModel: "Ajustar la caja al modelo completo",
        clipNudgeHint: "Paso de {{step}}.\nCon Mayús {{fine}}, con Alt {{coarse}}.\nMantén pulsada la flecha para repetir, más rápido cuanto más la mantengas.\nO haz clic en el número para escribir un valor exacto.",
        clipPrecisionHint: "Arrastra un control deslizante para cambios gruesos.\nMayús + arrastrar — fino, 1 m por píxel.\nAlt + arrastrar — extra grueso.\nLas flechas avanzan un paso; Mayús ▸ 1 m, Alt ▸ diez pasos.\nHaz clic en un número para escribir un valor exacto.\nEn la escena: arrastra una esquina para redimensionar, Mayús para mover la caja, Alt para un arrastre fino."
      }
    }
  },
}
